import type { IPricingPackage } from "../types";

export const usePricePackageOfPlan = (plan) => {
    const { activePricePackageIndex } = storeToRefs(usePricingStore());

    const pricePackage = computed((): IPricingPackage => {
        return plan.enterprise ? plan.price_packages[activePricePackageIndex.value] : plan.price_package;
    });

    return { pricePackage: pricePackage.value };
};
